<template>
  <div class="modelDisplayWrapper">
    <div class="header">
      <div class="btn" @click="goback">返回</div>

      <div class="header_left">
        <div class="shopCarBox">
          <gweb-shopcar-btn
          type="dot"
          :status="shopCarStatus"
          @onClick="gotoShopCar"
          />
          <span style="color:#ff8221">({{shopCarNum}})</span>
        </div>
        <span class="price">{{userInfo.vip ? '会员价' : '价格'}}: ￥{{userInfo.vip ? productInfo.vip_price : productInfo.price}}</span>
        <div class="btn addShopCarBtn" @click="addToCart">加入购物车</div>
      </div>
    </div>
    <div class="modelDisplay">
      <iframe :src="modelLink" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ShopCarButton, SearchInput, MultiPropFilter } from "gweb_ui";
export default {
  components: {
    [ShopCarButton.name]: ShopCarButton,
  },
  data() {
    return {
      productInfo: {}
    }
  },
  computed: {
    ...mapState([
      'userInfo', "shopCarInfo"
    ]),
    modelLink() {
      const reg = /index.html\?s=([^;])/;
      const result = this.productInfo.detail_value.model_link.replace(reg, 'index.html?s=y');
      return result;
    },
    shopCarNum(){
      // this.shopCarInfo[this.userInfo.id].length
      if(this.shopCarInfo[this.userInfo.id]){
        return this.shopCarInfo[this.userInfo.id].length
      }else{
        return 0
      }
      
    },
    shopCarStatus() {
      if (
        this.shopCarInfo[this.userInfo.id] &&
        this.shopCarInfo[this.userInfo.id].length !== 0
      ) {
        return "full";
      }
      return "empty";
    },
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    // 跳转购物车
    gotoShopCar() {
      this.$router.push({
        name: "personalCenterShopCar",
      });
    },
    addToCart() {
      if (!this.userInfo.hasOwnProperty("id")) {
        let pageTo = encodeURIComponent(location.href);
        if (process.env.NODE_ENV == "development") {
          location.href = "http://localhost:8010/login.html?other=true&pageTo=" + pageTo;
        } else {
          location.href = "./login.html?pageTo=" + pageTo;
        }
        return;
      }
      let goods = [this.productInfo].map((v) => ({
        ...v,
        pictures: v.picture,
        type: v.substrate,
        // ret_price: v.price,
        // price: v.vip_price,
        vip_price: v.price,
        price: v.price,
        color: v.model_link || v.color,
        brand_name: this.brand_name,
        num: 1
        // count: undefined,
      }));
      this.$store.commit("setShopCar", {
        shopCarInfo: {
          uid: this.$store.state.userInfo.id,
          supplierId: this.sid,
          items: goods,
        },
        mode: "add",
      });
      this.open();
    },
    open() {
      this.$confirm("添加成功,快去购物车看看吧", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({
            name: 'personalCenterShopCar',
          });
        })
        .catch(() => {});
    },
  },
  created() {
    this.productInfo = window.sessionStorage.getItem('productInfo') ? JSON.parse(window.sessionStorage.getItem('productInfo')) : {};
  }
}
</script>

<style lang="less" scoped>
.modelDisplayWrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
  box-sizing: border-box;
  padding-bottom: 20px;
}
.modelDisplay {
  width: 100%;
  flex: 1;
  iframe {
    width: 90%;
    margin: auto;
    height: 100%;
  }
}

.header {
  margin: 20px auto 10px auto;
  width: 90%;
  display: flex;
  justify-content: space-between;
  
  .btn {
    display: inline-block;
    line-height: 2em;
    padding: 0 20px;
    border-radius: 4px;
    border: solid 1px #333;
    cursor: pointer;
  }
  .header_left{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .shopCarBox{
      // border: 1px solid red;
      line-height: 30px;
      height: 30px;
      display: flex;
      align-content: center;
      span{
        margin-left: 10px;
      }
    }
    .price {
      margin: 0 20px;
      font-size: 16px;
      font-weight: bold;
      color: rgb(255, 130, 33);

    }
    .addShopCarBtn {
      background-color: rgb(255, 130, 33);
      color: white;
      border: solid 1px rgb(255, 130, 33);
      &:hover {
        background-color: rgb(248, 150, 76);
        border: solid 1px rgb(248, 150, 76);
      }
    }
  }
  
  
}
</style>